import React, { useEffect, useState } from "react";
import Select from "react-select";
import './SelectInput.scss';

interface Option {
    label: string;
    value: any;
};
interface Props {
    options?: Array<Option>;
    defaultValue?: any;
    name?: string;
    onChange?: (val: any) => void;
    isInvalid?: boolean;
    placeholder?: string;
    isSearchable?: boolean;
    closeMenuOnSelect?: boolean;
}
const SelectInput = React.forwardRef((props: Props, ref: any) => {
    const { options = [], name, onChange, defaultValue, isInvalid, placeholder, isSearchable = true, closeMenuOnSelect = true } = props;
    const [selection, setSelection] = useState<Option>();

    if (defaultValue) {
        const initalValue = options.find((option: any) => option.value === defaultValue)
        if (!selection && initalValue) {
            setSelection(initalValue);
        }
    }

    useEffect(() => {
        const initialValue = options.find((option: any) => option.value === defaultValue)
        if (!selection && initialValue) {
            setSelection(initialValue);
        }

    }, [defaultValue])

    const handleChange = (selected: any) => {
        setSelection(selected);
        if (onChange) {
            onChange(selected)
        }
    };

    const customStyles = {
        control: (base: any, state: any) => ({
            ...base,
            cursor: 'pointer',
            // state.isFocused can display different borderColor if you need it
            borderColor: state.isFocused ? '#ced4da' : isInvalid ? '#dc3545' : '#ced4da',
            // overwrittes hover style
            '&:hover': {
                borderColor: state.isFocused ? '#ced4da' : isInvalid ? '#dc3545' : '#ced4da',
            },
            '&:active': {
                borderColor: state.isFocused ? '#ced4da' : isInvalid ? '#dc3545' : '#ced4da',
            },
            '&:focus': {
                borderColor: state.isFocused ? '#ced4da' : isInvalid ? '#dc3545' : '#ced4da',
            }
        }),
        option: (styles: any, state: any) => ({
            ...styles,
            cursor: 'pointer',
        }),
    }

    return (
        <Select
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    danger: '#dc3545',
                    primary: '#562aa2',
                },
            })}
            placeholder={placeholder}
            styles={customStyles}
            options={options}
            isLoading={!options}
            isSearchable={isSearchable}
            closeMenuOnSelect={closeMenuOnSelect}
            onChange={(val) => {
                handleChange(val)
            }}
            value={selection}
            name={name}
            ref={ref}
        />
    );
});

export default SelectInput